/* eslint-disable */
// @ts-nocheck
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  /**
   * The `BigInt` scalar type represents non-fractional whole numeric values.
   * `BigInt` is not constrained to 32-bit like the `Int` type and thus is a less
   * compatible type.
   */
  BigInt: { input: number; output: number };
  /**
   * The `Date` scalar type represents a Date
   * value as specified by
   * [iso8601](https://en.wikipedia.org/wiki/ISO_8601).
   */
  Date: { input: string; output: string };
  /**
   * The `DateTime` scalar type represents a DateTime
   * value as specified by
   * [iso8601](https://en.wikipedia.org/wiki/ISO_8601).
   */
  DateTime: { input: string; output: string };
  /**
   * The `GenericScalar` scalar type represents a generic
   * GraphQL scalar value that could be:
   * String, Boolean, Int, Float, List or Object.
   */
  GenericScalar: { input: any; output: any };
  join__FieldSet: { input: unknown; output: unknown };
  link__Import: { input: unknown; output: unknown };
};

export type AccountDetail = {
  __typename?: "AccountDetail";
  contractedRowCount?: Maybe<Scalars["BigInt"]["output"]>;
  dailySummaryRecipients?: Maybe<Scalars["GenericScalar"]["output"]>;
  dailySummaryTime?: Maybe<Scalars["String"]["output"]>;
  defaultDeadline?: Maybe<Scalars["String"]["output"]>;
  name: Scalars["String"]["output"];
  nextDailySend?: Maybe<Scalars["DateTime"]["output"]>;
  showDownloadSummary?: Maybe<Scalars["Boolean"]["output"]>;
  urlName: Scalars["String"]["output"];
  users: Array<AccountLoginDetail>;
};

export type AccountLoginDetail = {
  __typename?: "AccountLoginDetail";
  email: Scalars["String"]["output"];
  name: Scalars["String"]["output"];
  /** Roles for this account-login. */
  roles: Array<Scalars["String"]["output"]>;
};

export type AccountV2 = {
  __typename?: "AccountV2";
  dailySummaryRecipients?: Maybe<Scalars["GenericScalar"]["output"]>;
  dailySummaryTime?: Maybe<Scalars["String"]["output"]>;
  defaultDeadline?: Maybe<Scalars["String"]["output"]>;
  name: Scalars["String"]["output"];
  nextDailySend?: Maybe<Scalars["DateTime"]["output"]>;
  show_download_summary?: Maybe<Scalars["Boolean"]["output"]>;
  urlName: Scalars["String"]["output"];
};

export type AccountV2Connection = {
  __typename?: "AccountV2Connection";
  edges: Array<AccountV2Edge>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

export type AccountV2Edge = {
  __typename?: "AccountV2Edge";
  cursor: Scalars["String"]["output"];
  node: AccountV2;
};

export type AddFileResult = ChangeFileSuccess | FileExists | MissingSha;

export type AttachedToMoreAccountsError = {
  __typename?: "AttachedToMoreAccountsError";
  message: Scalars["String"]["output"];
};

export type Auth0Identity = {
  __typename?: "Auth0Identity";
  blocked: Scalars["Boolean"]["output"];
  connectionType: Scalars["String"]["output"];
  email: Scalars["String"]["output"];
  emailVerified: Scalars["Boolean"]["output"];
  id: Scalars["String"]["output"];
  name: Scalars["String"]["output"];
};

export type Backfill = {
  __typename?: "Backfill";
  cancelled_by?: Maybe<User>;
  cancelled_on?: Maybe<Scalars["DateTime"]["output"]>;
  /** Number of processing pipelines that have been cancelled. Will be null until the backfill has been planned. */
  cancelled_pipelines?: Maybe<Scalars["Int"]["output"]>;
  changelist: Changelist;
  created_by: User;
  created_on: Scalars["DateTime"]["output"];
  /** Longer more discursive text describing the backfill; only displayed when digging into a particular backfill. */
  description: Scalars["String"]["output"];
  download_names: Array<Scalars["String"]["output"]>;
  /** The end of the report datetimes to backfill, inclusive */
  end_datetime: Scalars["DateTime"]["output"];
  /** Number of processing pipelines that have failed. Will be null until the backfill has been planned. */
  failed_pipelines?: Maybe<Scalars["Int"]["output"]>;
  /** The processing pipelines of this backfill. Will be null until the backfill has beenplanned. */
  flows?: Maybe<Array<Flow>>;
  /** True if the backfill has flows that have downloads with dirty rows, false otherwise */
  hasDirtyRows?: Maybe<Scalars["Boolean"]["output"]>;
  id: Scalars["String"]["output"];
  /** The start of the report datetimes to backfill, inclusive */
  start_datetime: Scalars["DateTime"]["output"];
  status: Scalars["String"]["output"];
  subgraph: Subgraph;
  /** Number of processing pipelines that have completed successfully. Will be null until the backfill has been planned. */
  succeeded_pipelines?: Maybe<Scalars["Int"]["output"]>;
  /** Short text describing the backfill; used for headings, lists of backfills, messages, etc. */
  title: Scalars["String"]["output"];
  /** Total number of processing pipelines. Will be null until the backfill as been planned. */
  total_pipelines?: Maybe<Scalars["Int"]["output"]>;
  upload_names: Array<Scalars["String"]["output"]>;
};

export type BackfillConnection = {
  __typename?: "BackfillConnection";
  edges: Array<BackfillEdge>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

export type BackfillEdge = {
  __typename?: "BackfillEdge";
  cursor: Scalars["String"]["output"];
  node: Backfill;
};

export type BackfillSourceBundle = {
  __typename?: "BackfillSourceBundle";
  handles: Array<Maybe<Scalars["GenericScalar"]["output"]>>;
  ok: Scalars["Boolean"]["output"];
};

export type ChangeFileSuccess = {
  __typename?: "ChangeFileSuccess";
  compilation: ScriptbookCompilation;
  newFileSha: Scalars["String"]["output"];
  newScriptbookSha: Scalars["String"]["output"];
};

export type Changelist = {
  __typename?: "Changelist";
  archived: Scalars["Boolean"]["output"];
  branched_from?: Maybe<Scalars["String"]["output"]>;
  compilation_result?: Maybe<CompilationResult>;
  created_by: User;
  created_on: Scalars["DateTime"]["output"];
  description: Scalars["String"]["output"];
  files: Array<File>;
  flow_summary?: Maybe<FlowSummary>;
  id: Scalars["String"]["output"];
  needs_merge?: Maybe<Scalars["Boolean"]["output"]>;
  published_by?: Maybe<User>;
  published_on?: Maybe<Scalars["DateTime"]["output"]>;
  status: Scalars["String"]["output"];
  updated_by: User;
  updated_on: Scalars["DateTime"]["output"];
};

export type ChangelistFilesArgs = {
  paths?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type ChangelistConnection = {
  __typename?: "ChangelistConnection";
  edges: Array<ChangelistEdge>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/**
 * Given two changelist ids, produce a diff information object. This includes:
 * 1. Unchanged files
 * 2. Changed files. Given the current structure, this automatically implies name hasnt been changed.
 * 3. Deleted files.
 * 4. Created files.
 */
export type ChangelistDiff = {
  __typename?: "ChangelistDiff";
  created_files: Array<Scalars["String"]["output"]>;
  deleted_files: Array<Scalars["String"]["output"]>;
  modified_files: Array<Scalars["String"]["output"]>;
  modified_id: Scalars["String"]["output"];
  original_id?: Maybe<Scalars["String"]["output"]>;
  unchanged_files: Array<Scalars["String"]["output"]>;
};

export type ChangelistEdge = {
  __typename?: "ChangelistEdge";
  cursor: Scalars["String"]["output"];
  node: Changelist;
};

export type CompilationDeclaration = {
  __typename?: "CompilationDeclaration";
  column: Scalars["Int"]["output"];
  connector_type: Scalars["String"]["output"];
  declaration_type: Scalars["String"]["output"];
  key_name?: Maybe<Scalars["String"]["output"]>;
  line: Scalars["Int"]["output"];
  name: Scalars["String"]["output"];
  path: Scalars["String"]["output"];
  test: Scalars["Boolean"]["output"];
};

export type CompilationMessage = {
  __typename?: "CompilationMessage";
  column: Scalars["Int"]["output"];
  endColumn: Scalars["Int"]["output"];
  endLine: Scalars["Int"]["output"];
  line: Scalars["Int"]["output"];
  message: Scalars["String"]["output"];
  path: Scalars["String"]["output"];
  startColumn: Scalars["Int"]["output"];
  startLine: Scalars["Int"]["output"];
  type: Scalars["String"]["output"];
};

export type CompilationResult = {
  __typename?: "CompilationResult";
  declarations?: Maybe<Array<CompilationDeclaration>>;
  messages?: Maybe<Array<CompilationMessage>>;
};

export type ConflictingBackfillsError = {
  __typename?: "ConflictingBackfillsError";
  conflicting_backfills: Array<Backfill>;
};

export type ConflictingEmailError = {
  __typename?: "ConflictingEmailError";
  message: Scalars["String"]["output"];
};

export type ConflictingNameError = {
  __typename?: "ConflictingNameError";
  message: Scalars["String"]["output"];
};

export type ConflictingUrlNameError = {
  __typename?: "ConflictingUrlNameError";
  message: Scalars["String"]["output"];
};

export type Credential = {
  __typename?: "Credential";
  credential_type: Scalars["String"]["output"];
  description?: Maybe<Scalars["String"]["output"]>;
  exist?: Maybe<Scalars["Boolean"]["output"]>;
  id?: Maybe<Scalars["Int"]["output"]>;
  name: Scalars["String"]["output"];
  properties?: Maybe<Scalars["GenericScalar"]["output"]>;
  properties_exist?: Maybe<Scalars["GenericScalar"]["output"]>;
  /** Datetime of most recent successful use. */
  recent_use?: Maybe<Scalars["DateTime"]["output"]>;
  status: Scalars["String"]["output"];
};

export type CredentialRecentUseArgs = {
  if_suspended?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type CredentialConnection = {
  __typename?: "CredentialConnection";
  edges: Array<CredentialEdge>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

export type CredentialEdge = {
  __typename?: "CredentialEdge";
  cursor: Scalars["String"]["output"];
  node: Credential;
};

export enum DataGridSortableColumns {
  Created = "CREATED",
  Finished = "FINISHED",
  ReportDatetime = "REPORT_DATETIME",
  Started = "STARTED",
}

export type DateTimeHuman = {
  __typename?: "DateTimeHuman";
  iso: Scalars["String"]["output"];
  long: Scalars["String"]["output"];
  long_utc: Scalars["String"]["output"];
  short: Scalars["String"]["output"];
  short_utc: Scalars["String"]["output"];
};

export type DeactivateAccountV2 = {
  __typename?: "DeactivateAccountV2";
  ok: Scalars["Boolean"]["output"];
};

export type Download = {
  __typename?: "Download";
  bqDataset?: Maybe<Scalars["String"]["output"]>;
  bqProject?: Maybe<Scalars["String"]["output"]>;
  bundleId?: Maybe<Scalars["String"]["output"]>;
  declarationId: Scalars["String"]["output"];
  importType: Scalars["String"]["output"];
  isBundleParent: Scalars["Boolean"]["output"];
  line?: Maybe<Scalars["Int"]["output"]>;
  name: Scalars["String"]["output"];
  query?: Maybe<Scalars["String"]["output"]>;
  sbProject?: Maybe<Scalars["String"]["output"]>;
  subgraphId: Scalars["String"]["output"];
  table?: Maybe<Scalars["String"]["output"]>;
  uploads: Array<Scalars["String"]["output"]>;
};

export type DownloadBundle = {
  __typename?: "DownloadBundle";
  created: Scalars["DateTime"]["output"];
  finished?: Maybe<Scalars["DateTime"]["output"]>;
  handle?: Maybe<Scalars["GenericScalar"]["output"]>;
  id: Scalars["String"]["output"];
  notes?: Maybe<Scalars["GenericScalar"]["output"]>;
  parts?: Maybe<Array<Maybe<DownloadPart>>>;
  progress?: Maybe<Scalars["GenericScalar"]["output"]>;
  purpose: Scalars["String"]["output"];
  report_datetime?: Maybe<DateTimeHuman>;
  source_tables: Array<Maybe<SourceTable>>;
  started?: Maybe<Scalars["DateTime"]["output"]>;
  status: Scalars["String"]["output"];
  tasks?: Maybe<Array<Maybe<Task>>>;
};

export type DownloadBundleConnection = {
  __typename?: "DownloadBundleConnection";
  edges: Array<DownloadBundleEdge>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

export type DownloadBundleEdge = {
  __typename?: "DownloadBundleEdge";
  cursor: Scalars["String"]["output"];
  node: DownloadBundle;
};

export type DownloadDependencySummary = {
  __typename?: "DownloadDependencySummary";
  name: Scalars["String"]["output"];
  status: Scalars["String"]["output"];
};

export type DownloadDetails = {
  __typename?: "DownloadDetails";
  event?: Maybe<HomepageEvent>;
  keysUsedByDownload: Array<KeyDependencySummary>;
  pos: Position;
  refreshedAt: Scalars["String"]["output"];
  scriptbookId: Scalars["String"]["output"];
  scriptbookKey: Scalars["String"]["output"];
  sparkline: Array<HomepageSparklineDay>;
  sparklineFirstDate: Scalars["String"]["output"];
  status: Scalars["String"]["output"];
  uploadsUsingDownload: Array<UploadDependencySummary>;
};

export type DownloadJournal = {
  __typename?: "DownloadJournal";
  _name?: Maybe<Scalars["String"]["output"]>;
  completed: Scalars["Int"]["output"];
  date?: Maybe<Scalars["Date"]["output"]>;
  dirty_rows: Scalars["Boolean"]["output"];
  failed: Scalars["Int"]["output"];
  max_bytes: Scalars["Float"]["output"];
  max_rows: Scalars["Float"]["output"];
  min_bytes: Scalars["Float"]["output"];
  min_rows: Scalars["Float"]["output"];
  running: Scalars["Int"]["output"];
  total_bytes: Scalars["Float"]["output"];
  total_rows: Scalars["Float"]["output"];
};

export type DownloadPart = {
  __typename?: "DownloadPart";
  dirty_row_count?: Maybe<Scalars["Float"]["output"]>;
  dirty_row_status?: Maybe<Scalars["String"]["output"]>;
  download: DownloadBundle;
  hasConnectedUploadDeclarations?: Maybe<Scalars["Boolean"]["output"]>;
  id: Scalars["String"]["output"];
  legacy_flow_source_id?: Maybe<Scalars["String"]["output"]>;
  name: Scalars["String"]["output"];
  new_dirty_row_count?: Maybe<Scalars["Float"]["output"]>;
  new_dirty_row_status?: Maybe<Scalars["String"]["output"]>;
  report_datetime?: Maybe<DateTimeHuman>;
  row_count?: Maybe<Scalars["Float"]["output"]>;
  source_table: SourceTable;
};

export type EmailConfig = {
  __typename?: "EmailConfig";
  accountId: Scalars["Int"]["output"];
  deactivatedOn?: Maybe<Scalars["DateTime"]["output"]>;
  id: Scalars["String"]["output"];
  links?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
  matchOrder?: Maybe<Scalars["Int"]["output"]>;
  path: Scalars["String"]["output"];
  recipient: Scalars["String"]["output"];
  senderGlob?: Maybe<Scalars["String"]["output"]>;
  senderRegex?: Maybe<Scalars["String"]["output"]>;
  subjectGlob?: Maybe<Scalars["String"]["output"]>;
  subjectRegex?: Maybe<Scalars["String"]["output"]>;
};

export type Event = {
  __typename?: "Event";
  all_rows_dirty_skipped_uploads?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
  all_rows_dirty_suspended_downloads?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
  comment?: Maybe<Scalars["String"]["output"]>;
  commented_by?: Maybe<User>;
  commented_on?: Maybe<Scalars["DateTime"]["output"]>;
  created: Scalars["DateTime"]["output"];
  credential?: Maybe<Credential>;
  download?: Maybe<DownloadBundle>;
  download_declaration?: Maybe<SourceTable>;
  flow?: Maybe<FlowSe>;
  id: Scalars["String"]["output"];
  message?: Maybe<Scalars["String"]["output"]>;
  project_name?: Maybe<Scalars["String"]["output"]>;
  purpose?: Maybe<Scalars["String"]["output"]>;
  report_datetime?: Maybe<Scalars["DateTime"]["output"]>;
  retry_count?: Maybe<Scalars["Int"]["output"]>;
  retry_limit?: Maybe<Scalars["Int"]["output"]>;
  severity?: Maybe<Scalars["String"]["output"]>;
  some_rows_dirty_downloads?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
  upload?: Maybe<Upload>;
  upload_declaration?: Maybe<ExportDeclaration>;
  will_retry?: Maybe<Scalars["Boolean"]["output"]>;
};

export type EventConnection = {
  __typename?: "EventConnection";
  edges: Array<EventEdge>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

export type EventEdge = {
  __typename?: "EventEdge";
  cursor: Scalars["String"]["output"];
  node: Event;
};

export type ExportDeclaration = {
  __typename?: "ExportDeclaration";
  changelist_id: Scalars["String"]["output"];
  credential?: Maybe<Credential>;
  /** Deadline explicitly set for this export; null if no deadline explicitly set for this export. */
  deadline?: Maybe<Scalars["String"]["output"]>;
  /** True if deadline applies to this export; false if account default deadline applies. */
  deadline_override?: Maybe<Scalars["Boolean"]["output"]>;
  descriptor: Scalars["GenericScalar"]["output"];
  destination?: Maybe<Scalars["String"]["output"]>;
  export_type: Scalars["GenericScalar"]["output"];
  id: Scalars["String"]["output"];
  line: Scalars["Int"]["output"];
  name: Scalars["String"]["output"];
  /** From export setting or account default; may be in the recent past if we have yet to check. */
  next_deadline?: Maybe<Scalars["DateTime"]["output"]>;
  project: Scalars["String"]["output"];
  /** Datetime of most recent uploads */
  recent_upload?: Maybe<Scalars["DateTime"]["output"]>;
  schema?: Maybe<Scalars["GenericScalar"]["output"]>;
  status: Scalars["String"]["output"];
  subgraph?: Maybe<Subgraph>;
  test_parameters: Scalars["GenericScalar"]["output"];
  upload_parameters: Scalars["GenericScalar"]["output"];
};

export type ExportDeclarationRecentUploadArgs = {
  if_suspended?: InputMaybe<Scalars["Boolean"]["input"]>;
  purpose?: InputMaybe<Scalars["String"]["input"]>;
  status?: InputMaybe<Scalars["String"]["input"]>;
};

export type ExportDeclarationConnection = {
  __typename?: "ExportDeclarationConnection";
  edges: Array<ExportDeclarationEdge>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

export type ExportDeclarationEdge = {
  __typename?: "ExportDeclarationEdge";
  cursor: Scalars["String"]["output"];
  node: ExportDeclaration;
};

export type ExportStatus = {
  __typename?: "ExportStatus";
  credential?: Maybe<Credential>;
  journal?: Maybe<Array<Maybe<UploadJournal>>>;
  name?: Maybe<Scalars["String"]["output"]>;
  project?: Maybe<Scalars["String"]["output"]>;
  status?: Maybe<Scalars["String"]["output"]>;
};

export type ExportStatusConnection = {
  __typename?: "ExportStatusConnection";
  edges: Array<ExportStatusEdge>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

export type ExportStatusEdge = {
  __typename?: "ExportStatusEdge";
  cursor: Scalars["String"]["output"];
  node: ExportStatus;
};

export type File = {
  __typename?: "File";
  id: Scalars["ID"]["output"];
  path: Scalars["String"]["output"];
  text: Scalars["String"]["output"];
};

export type FileCompilation = SourceCompilation & {
  __typename?: "FileCompilation";
  beta: Scalars["Int"]["output"];
  errors: Scalars["Int"]["output"];
  fileKey: Scalars["String"]["output"];
  info: Scalars["Int"]["output"];
  messages: Array<Message>;
  path: Scalars["String"]["output"];
  text: Scalars["String"]["output"];
  warnings: Scalars["Int"]["output"];
};

/**
 * The file with that path already exists in the scriptbook. Use saveFile to
 * update it.
 */
export type FileExists = {
  __typename?: "FileExists";
  fileKey: Scalars["String"]["output"];
  path: Scalars["String"]["output"];
  scriptbookSha: Scalars["String"]["output"];
};

export type Flow = {
  __typename?: "Flow";
  archived: Scalars["Boolean"]["output"];
  backfill?: Maybe<Backfill>;
  changelist: Changelist;
  created: Scalars["DateTime"]["output"];
  events: Array<Maybe<Event>>;
  /** Deprecated, use status */
  failed: Scalars["Boolean"]["output"];
  finished?: Maybe<Scalars["DateTime"]["output"]>;
  id: Scalars["String"]["output"];
  inputs: Array<Maybe<FlowInput>>;
  launched_by: User;
  outputs: Array<Maybe<FlowOutput>>;
  phase: Scalars["String"]["output"];
  processing?: Maybe<Processing>;
  purpose: Scalars["String"]["output"];
  report_datetime?: Maybe<DateTimeHuman>;
  status: Scalars["String"]["output"];
};

export type FlowConnection = {
  __typename?: "FlowConnection";
  edges: Array<FlowEdge>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

export type FlowEdge = {
  __typename?: "FlowEdge";
  cursor: Scalars["String"]["output"];
  node: Flow;
};

export type FlowInput = {
  __typename?: "FlowInput";
  download?: Maybe<DownloadBundle>;
  download_part?: Maybe<DownloadPart>;
  name: Scalars["String"]["output"];
  source_table: SourceTable;
};

/**
 * GraphQL structure like to FlowInput for forward compatibility, but limited to needs of events query and
 * capabilities of FlowsSE.
 */
export type FlowInputSe = {
  __typename?: "FlowInputSE";
  source_table: SourceTable;
};

export type FlowOutput = {
  __typename?: "FlowOutput";
  created?: Maybe<Scalars["DateTime"]["output"]>;
  declaration: ExportDeclaration;
  destination?: Maybe<Scalars["String"]["output"]>;
  finished?: Maybe<Scalars["DateTime"]["output"]>;
  handle?: Maybe<Scalars["GenericScalar"]["output"]>;
  id: Scalars["String"]["output"];
  name: Scalars["String"]["output"];
  project: Scalars["String"]["output"];
  report_datetime?: Maybe<DateTimeHuman>;
  row_count?: Maybe<Scalars["Float"]["output"]>;
  started?: Maybe<Scalars["DateTime"]["output"]>;
  status?: Maybe<Scalars["String"]["output"]>;
};

/**
 * GraphQL structure like to FlowOutput for forward compatibility, but limited to needs of events query and
 * capabilities of FlowsSE.
 */
export type FlowOutputSe = {
  __typename?: "FlowOutputSE";
  declaration: ExportDeclaration;
};

/**
 * GraphQL structure like to Flow for forward compatibility, but limited to needs of events query and
 * capabilities of FlowsSE.
 */
export type FlowSe = {
  __typename?: "FlowSE";
  id: Scalars["String"]["output"];
  inputs: Array<Maybe<FlowInputSe>>;
  outputs: Array<Maybe<FlowOutputSe>>;
};

export type FlowSummary = {
  __typename?: "FlowSummary";
  dirty_rows_all: Scalars["Int"]["output"];
  dirty_rows_some: Scalars["Int"]["output"];
  failed: Scalars["Int"]["output"];
  purpose: Scalars["String"]["output"];
  succeeded: Scalars["Int"]["output"];
  unfinished: Scalars["Int"]["output"];
};

export type GenericResult = GenericSuccess | MissingSha;

export type GenericSuccess = {
  __typename?: "GenericSuccess";
  compilation: ScriptbookCompilation;
  newScriptbookSha: Scalars["String"]["output"];
};

export type Homepage = {
  __typename?: "Homepage";
  downloads: Array<HomepageDownloadSummary>;
  refreshedAt: Scalars["String"]["output"];
  sparklineDates: Array<Scalars["String"]["output"]>;
  sparklineFirstDate: Scalars["String"]["output"];
  suspendedKeys: Array<HomepageKeySummary>;
  uploads: Array<HomepageUploadSummary>;
};

export type HomepageDownloadSummary = {
  __typename?: "HomepageDownloadSummary";
  artifactStatus: Scalars["String"]["output"];
  dependencyStatus: Scalars["String"]["output"];
  event?: Maybe<HomepageEvent>;
  keys: Array<Scalars["String"]["output"]>;
  name: Scalars["String"]["output"];
  pos: Position;
  sparkline: Array<HomepageSparklineDay>;
  status: Scalars["String"]["output"];
};

export type HomepageEvent = {
  __typename?: "HomepageEvent";
  created: Scalars["String"]["output"];
  eventId: Scalars["String"]["output"];
  message: Scalars["String"]["output"];
  purpose: Scalars["String"]["output"];
  qualname: Scalars["String"]["output"];
  severity: Scalars["String"]["output"];
  willRetry: Scalars["Boolean"]["output"];
};

export type HomepageKeySummary = {
  __typename?: "HomepageKeySummary";
  event?: Maybe<HomepageEvent>;
  name: Scalars["String"]["output"];
};

export type HomepageResult = Homepage | NoPublishedScriptbook;

export type HomepageSparklineDay = {
  __typename?: "HomepageSparklineDay";
  running: Scalars["Boolean"]["output"];
  status: Scalars["String"]["output"];
};

export type HomepageUploadSummary = {
  __typename?: "HomepageUploadSummary";
  artifactStatus: Scalars["String"]["output"];
  dependencies: Array<Scalars["String"]["output"]>;
  dependencyStatus: Scalars["String"]["output"];
  destination?: Maybe<Scalars["String"]["output"]>;
  event?: Maybe<HomepageEvent>;
  keys: Array<Scalars["String"]["output"]>;
  name: Scalars["String"]["output"];
  pos: Position;
  sparkline: Array<HomepageSparklineDay>;
  status: Scalars["String"]["output"];
};

export type ImportStatus = {
  __typename?: "ImportStatus";
  credential?: Maybe<Credential>;
  journal?: Maybe<Array<Maybe<DownloadJournal>>>;
  name?: Maybe<Scalars["String"]["output"]>;
  project?: Maybe<Scalars["String"]["output"]>;
  status?: Maybe<Scalars["String"]["output"]>;
};

export type ImportStatusConnection = {
  __typename?: "ImportStatusConnection";
  edges: Array<ImportStatusEdge>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

export type ImportStatusEdge = {
  __typename?: "ImportStatusEdge";
  cursor: Scalars["String"]["output"];
  node: ImportStatus;
};

export type InsecurePasswordError = {
  __typename?: "InsecurePasswordError";
  message: Scalars["String"]["output"];
  passwordErrors?: Maybe<Array<Scalars["String"]["output"]>>;
};

export type Integration = {
  __typename?: "Integration";
  assistance?: Maybe<Scalars["GenericScalar"]["output"]>;
  channel_by_id?: Maybe<Scalars["GenericScalar"]["output"]>;
  configuration?: Maybe<Scalars["GenericScalar"]["output"]>;
  filters: Array<Maybe<IntegrationFilter>>;
  id: Scalars["String"]["output"];
  integration_type: Scalars["String"]["output"];
  public_authorization?: Maybe<Scalars["GenericScalar"]["output"]>;
  status: Scalars["String"]["output"];
};

export type IntegrationChannelByIdArgs = {
  channel_id: Scalars["String"]["input"];
};

export type IntegrationConnection = {
  __typename?: "IntegrationConnection";
  edges: Array<IntegrationEdge>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

export type IntegrationEdge = {
  __typename?: "IntegrationEdge";
  cursor: Scalars["String"]["output"];
  node: Integration;
};

export type IntegrationFilter = {
  __typename?: "IntegrationFilter";
  backfills: Scalars["Boolean"]["output"];
  beta: Scalars["Boolean"]["output"];
  configuration?: Maybe<Scalars["GenericScalar"]["output"]>;
  id: Scalars["String"]["output"];
  lateUploads: Scalars["Boolean"]["output"];
  production: Scalars["Boolean"]["output"];
  proofs: Scalars["Boolean"]["output"];
  status: Scalars["String"]["output"];
};

export type IntegrationFilterInput = {
  backfills?: InputMaybe<Scalars["Boolean"]["input"]>;
  beta?: InputMaybe<Scalars["Boolean"]["input"]>;
  configuration?: InputMaybe<Scalars["GenericScalar"]["input"]>;
  id?: InputMaybe<Scalars["String"]["input"]>;
  lateUploads?: InputMaybe<Scalars["Boolean"]["input"]>;
  production?: InputMaybe<Scalars["Boolean"]["input"]>;
  proofs?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type InvalidCredential = {
  __typename?: "InvalidCredential";
  message: Scalars["String"]["output"];
};

export type InvalidPathError = {
  __typename?: "InvalidPathError";
  field: Scalars["String"]["output"];
  message: Scalars["String"]["output"];
};

export type InvalidRegexError = {
  __typename?: "InvalidRegexError";
  field: Scalars["String"]["output"];
  message: Scalars["String"]["output"];
};

export type KeyDependencySummary = {
  __typename?: "KeyDependencySummary";
  name: Scalars["String"]["output"];
  status: Scalars["String"]["output"];
};

export type KeyDetails = {
  __typename?: "KeyDetails";
  downloadsUsingKey: Array<DownloadDependencySummary>;
  event?: Maybe<HomepageEvent>;
  keyStatus: Scalars["String"]["output"];
  refreshedAt: Scalars["String"]["output"];
  uploadsUsingKey: Array<UploadDependencySummary>;
};

export type LateUpload = {
  __typename?: "LateUpload";
  /** Number of days after the deadline before late/missing status is reported. */
  alert_delay?: Maybe<Scalars["Int"]["output"]>;
  /** The recent deadline; will be in the past. */
  deadline?: Maybe<Scalars["DateTime"]["output"]>;
  /** We evaluate the deadline only if it is 24 hours after the export was created. */
  export_created?: Maybe<Scalars["DateTime"]["output"]>;
  /** The time the first late upload finished. */
  first_completed_since_deadline?: Maybe<Scalars["DateTime"]["output"]>;
  /** True if any credential or import suspension has impacted this export. */
  impacted?: Maybe<Scalars["Boolean"]["output"]>;
  /** The time the most recent upload before the deadline finished. */
  last_completed_before_deadline?: Maybe<Scalars["DateTime"]["output"]>;
  /** good: at least one upload within 24 hours before deadline; late: not good, but at least one upload since deadline; missing: no uploads since 24 hours before deadline */
  late_status?: Maybe<Scalars["String"]["output"]>;
  /** The export name */
  name?: Maybe<Scalars["String"]["output"]>;
};

export type LaunchBackfillInput = {
  changelist_id?: InputMaybe<Scalars["String"]["input"]>;
  description: Scalars["String"]["input"];
  end_datetime: Scalars["DateTime"]["input"];
  start_datetime: Scalars["DateTime"]["input"];
  title: Scalars["String"]["input"];
  upload_names: Array<InputMaybe<Scalars["String"]["input"]>>;
};

export type LaunchBackfillOutput = Backfill | ConflictingBackfillsError;

export type Me = {
  __typename?: "Me";
  accounts: Array<UserAccounts>;
  default_url_name?: Maybe<Scalars["String"]["output"]>;
  email: Scalars["String"]["output"];
  name: Scalars["String"]["output"];
  /** Permissions for this login, depending on context. */
  permissions: Array<Scalars["String"]["output"]>;
  /** Roles for this login, depending on context. */
  roles: Array<Scalars["String"]["output"]>;
};

export type Message = {
  __typename?: "Message";
  endColumn: Scalars["Int"]["output"];
  endLine: Scalars["Int"]["output"];
  message: Scalars["String"]["output"];
  path: Scalars["String"]["output"];
  startColumn: Scalars["Int"]["output"];
  startLine: Scalars["Int"]["output"];
  type: Scalars["String"]["output"];
};

/**
 * The scriptbook SHA or some source SHA are not available in the compiler's
 * cache. The client should call `uploadScriptbook` to provide the missing
 * information.
 */
export type MissingSha = {
  __typename?: "MissingSha";
  destSha: Array<Scalars["String"]["output"]>;
  fileSha: Array<Scalars["String"]["output"]>;
  scriptbookSha?: Maybe<Scalars["String"]["output"]>;
  srcSha: Array<Scalars["String"]["output"]>;
};

export type Mutation = {
  __typename?: "Mutation";
  /**
   * Add one file in the scriptbook. The path must not already exist in the
   * scriptbook; use saveFile to update (rename or change text) an existing
   * path.
   */
  addFile: AddFileResult;
  backfill_source_bundle?: Maybe<BackfillSourceBundle>;
  branch_changelist?: Maybe<SaveChangelistOk>;
  deactivateAccountV2?: Maybe<DeactivateAccountV2>;
  launch_backfill?: Maybe<LaunchBackfillOutput>;
  /** Remove one file from the scriptbook. */
  removeFile: GenericResult;
  removeUserV2: RemoveUserV2Result;
  remove_integration?: Maybe<RemoveIntegration>;
  resetAuth0Password?: Maybe<ResetAuth0Password>;
  saveAccountV2: SaveAccountResult;
  /** Update one file (rename or change text) in the scriptbook. */
  saveFile: SaveFileResult;
  savePreference?: Maybe<SavePreference>;
  saveUserV2: SaveUserResult;
  save_backfill: Backfill;
  save_changelist?: Maybe<SaveChangelistResult>;
  save_credential?: Maybe<SaveCredentialOutput>;
  save_download?: Maybe<SaveDownloadBundle>;
  /** Create a new email config or update an existing one */
  save_emailconfig?: Maybe<EmailConfig>;
  /** Create a new email match or update an existing one */
  save_emailmatch?: Maybe<SaveEmailMatchResult>;
  /** Create a new email recipient or update an existing one */
  save_emailrecipient?: Maybe<SaveEmailRecipientResult>;
  save_event?: Maybe<SaveEvent>;
  save_export?: Maybe<SaveExport>;
  save_flow?: Maybe<SaveFlow>;
  save_integration?: Maybe<SaveIntegration>;
  save_source_bundle?: Maybe<SaveSourceBundle>;
  save_upload?: Maybe<SaveUpload>;
  setAuth0UserBlock?: Maybe<SetUserBlock>;
  /**
   * Upload a scriptbook to the cache. The client must provide all the files in
   * the scriptbook, either by listing the SHA or by providing the files
   * themselves. The client can list the SHA for files that it has learned
   * exist in the cache, and needs to provide the files themselves only for
   * those that it has learned are missing from the cache. The client learns of
   * missing SHA whenever any operation returns `MissingSha`.
   */
  uploadScriptbook: GenericResult;
  validate_integration?: Maybe<ValidateIntegration>;
};

export type MutationAddFileArgs = {
  path: Scalars["String"]["input"];
  scriptbookSha: Scalars["String"]["input"];
  text: Scalars["String"]["input"];
};

export type MutationBackfillSourceBundleArgs = {
  concurrent_downloads?: InputMaybe<Scalars["Int"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  since: Scalars["DateTime"]["input"];
  until: Scalars["DateTime"]["input"];
};

export type MutationBranchChangelistArgs = {
  changelist_id?: InputMaybe<Scalars["String"]["input"]>;
  description: Scalars["String"]["input"];
};

export type MutationDeactivateAccountV2Args = {
  urlName: Scalars["String"]["input"];
};

export type MutationLaunchBackfillArgs = {
  backfill: LaunchBackfillInput;
};

export type MutationRemoveFileArgs = {
  fileKey: Scalars["String"]["input"];
  scriptbookSha: Scalars["String"]["input"];
};

export type MutationRemoveUserV2Args = {
  email: Scalars["String"]["input"];
  urlName?: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationRemoveIntegrationArgs = {
  id: Scalars["String"]["input"];
};

export type MutationResetAuth0PasswordArgs = {
  email: Scalars["String"]["input"];
};

export type MutationSaveAccountV2Args = {
  account: SaveAccountV2Input;
  urlName?: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationSaveFileArgs = {
  fileKey: Scalars["String"]["input"];
  path?: InputMaybe<Scalars["String"]["input"]>;
  scriptbookSha: Scalars["String"]["input"];
  text?: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationSavePreferenceArgs = {
  name: Scalars["String"]["input"];
  value: Scalars["GenericScalar"]["input"];
};

export type MutationSaveUserV2Args = {
  email?: InputMaybe<Scalars["String"]["input"]>;
  roles?: InputMaybe<Array<Scalars["String"]["input"]>>;
  urlNames?: InputMaybe<Array<Scalars["String"]["input"]>>;
  user?: InputMaybe<SaveUserV2Input>;
};

export type MutationSaveBackfillArgs = {
  backfill: SaveBackfillInput;
  backfill_id: Scalars["String"]["input"];
};

export type MutationSaveChangelistArgs = {
  action?: InputMaybe<Scalars["String"]["input"]>;
  changelist?: InputMaybe<SaveChangelistInput>;
  changelist_id?: InputMaybe<Scalars["String"]["input"]>;
  fetch_new_downloads?: InputMaybe<Scalars["Boolean"]["input"]>;
  force_publish?: InputMaybe<Scalars["Boolean"]["input"]>;
  test_exports?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type MutationSaveCredentialArgs = {
  credential: SaveCredentialInput;
  name?: InputMaybe<Scalars["String"]["input"]>;
  replace_properties?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type MutationSaveDownloadArgs = {
  download: SaveStatusInput;
  id: Scalars["String"]["input"];
};

export type MutationSaveEmailconfigArgs = {
  accountId?: InputMaybe<Scalars["Int"]["input"]>;
  deactivatedOn?: InputMaybe<Scalars["DateTime"]["input"]>;
  id?: InputMaybe<Scalars["String"]["input"]>;
  links?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  matchOrder?: InputMaybe<Scalars["Int"]["input"]>;
  path?: InputMaybe<Scalars["String"]["input"]>;
  recipient?: InputMaybe<Scalars["String"]["input"]>;
  senderGlob?: InputMaybe<Scalars["String"]["input"]>;
  senderRegex?: InputMaybe<Scalars["String"]["input"]>;
  subjectGlob?: InputMaybe<Scalars["String"]["input"]>;
  subjectRegex?: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationSaveEmailmatchArgs = {
  deactivate?: InputMaybe<Scalars["Boolean"]["input"]>;
  id?: InputMaybe<Scalars["String"]["input"]>;
  recipient?: InputMaybe<Scalars["String"]["input"]>;
  rule?: InputMaybe<RuleInput>;
};

export type MutationSaveEmailrecipientArgs = {
  deactivate?: InputMaybe<Scalars["Boolean"]["input"]>;
  newRecipient?: InputMaybe<Scalars["String"]["input"]>;
  recipient: Scalars["String"]["input"];
};

export type MutationSaveEventArgs = {
  event: SaveEventInput;
  id: Scalars["String"]["input"];
};

export type MutationSaveExportArgs = {
  changelist_id?: InputMaybe<Scalars["String"]["input"]>;
  export: SaveExportInput;
  name?: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationSaveFlowArgs = {
  id: Scalars["String"]["input"];
  update: SaveFlowInput;
};

export type MutationSaveIntegrationArgs = {
  id?: InputMaybe<Scalars["String"]["input"]>;
  integration: SaveIntegrationInput;
};

export type MutationSaveSourceBundleArgs = {
  bundle: SaveSourceBundleInput;
  changelist_id?: InputMaybe<Scalars["String"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationSaveUploadArgs = {
  id: Scalars["String"]["input"];
  upload: SaveStatusInput;
};

export type MutationSetAuth0UserBlockArgs = {
  blocked: Scalars["Boolean"]["input"];
  id: Scalars["String"]["input"];
};

export type MutationUploadScriptbookArgs = {
  fileSha?: InputMaybe<Array<Scalars["String"]["input"]>>;
  files?: InputMaybe<Array<ScriptInput>>;
};

export type MutationValidateIntegrationArgs = {
  id?: InputMaybe<Scalars["String"]["input"]>;
  integration: SaveIntegrationInput;
};

export type NeedsMergeError = {
  __typename?: "NeedsMergeError";
  message: Scalars["String"]["output"];
};

export type NoPublishedScriptbook = {
  __typename?: "NoPublishedScriptbook";
  ok: Scalars["Boolean"]["output"];
};

/** The Relay compliant `PageInfo` type, containing data necessary to paginate this connection. */
export type PageInfo = {
  __typename?: "PageInfo";
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars["String"]["output"]>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars["Boolean"]["output"];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars["Boolean"]["output"];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars["String"]["output"]>;
};

export type PipelinesType = {
  __typename?: "PipelinesType";
  downloads?: Maybe<Array<Download>>;
  scriptbookDescription?: Maybe<Scalars["String"]["output"]>;
  scriptbookId?: Maybe<Scalars["String"]["output"]>;
  steps: Array<Step>;
  uploads?: Maybe<Array<UploadDeclaration>>;
};

export type Position = {
  __typename?: "Position";
  endColumn: Scalars["Int"]["output"];
  endLine: Scalars["Int"]["output"];
  path: Scalars["String"]["output"];
  startColumn: Scalars["Int"]["output"];
  startLine: Scalars["Int"]["output"];
};

export type Processing = {
  __typename?: "Processing";
  finished?: Maybe<Scalars["DateTime"]["output"]>;
  id: Scalars["String"]["output"];
  started?: Maybe<Scalars["DateTime"]["output"]>;
  status: Scalars["String"]["output"];
};

export type Query = {
  __typename?: "Query";
  account?: Maybe<AccountDetail>;
  accountsV2?: Maybe<AccountV2Connection>;
  backfill: Backfill;
  backfills?: Maybe<BackfillConnection>;
  changelist?: Maybe<Changelist>;
  changelist_diff?: Maybe<ChangelistDiff>;
  credential?: Maybe<Credential>;
  credentials?: Maybe<CredentialConnection>;
  download?: Maybe<DownloadBundle>;
  /** Details for a download. */
  downloadDetails: DownloadDetails;
  downloadRowsReport?: Maybe<RowsReport>;
  downloads?: Maybe<DownloadBundleConnection>;
  /** Current drafts of scriptbook changes. */
  drafts?: Maybe<ChangelistConnection>;
  emailconfigs?: Maybe<Array<EmailConfig>>;
  event?: Maybe<Event>;
  events?: Maybe<EventConnection>;
  export_declaration?: Maybe<ExportDeclaration>;
  export_declarations?: Maybe<ExportDeclarationConnection>;
  export_status?: Maybe<ExportStatusConnection>;
  flow_downloads?: Maybe<DownloadBundleConnection>;
  flows?: Maybe<FlowConnection>;
  getDataFlow?: Maybe<PipelinesType>;
  getSuspendedCredentialCount?: Maybe<Scalars["Int"]["output"]>;
  /** History of published scriptbooks. */
  history?: Maybe<ChangelistConnection>;
  /** All the things for the homepage. */
  homepage: HomepageResult;
  impactedDownloads?: Maybe<SourceTableConnection>;
  impactedUploads?: Maybe<ExportDeclarationConnection>;
  import_status?: Maybe<ImportStatusConnection>;
  integration?: Maybe<Integration>;
  integrations?: Maybe<IntegrationConnection>;
  /** Details for a key. */
  keyDetails: KeyDetails;
  /** List late status of uploads that have a deadline; does not list exports with no deadline. */
  late_uploads?: Maybe<Array<Maybe<LateUpload>>>;
  meV2?: Maybe<Me>;
  recipients?: Maybe<Array<Recipient>>;
  sbs_schema?: Maybe<SbsSchema>;
  sbs_schemas?: Maybe<Array<Maybe<SbsSchema>>>;
  /** Get the scriptbook compilation, and also its files from the database. */
  scriptbook: GenericResult;
  source_bundle?: Maybe<SourceBundle>;
  source_bundles?: Maybe<SourceBundleConnection>;
  source_table?: Maybe<SourceTable>;
  start_oauth?: Maybe<Scalars["String"]["output"]>;
  tasks?: Maybe<TaskConnection>;
  upload?: Maybe<Upload>;
  /** Details for an upload. */
  uploadDetails: UploadDetails;
  uploads?: Maybe<UploadConnection>;
  userPreference?: Maybe<Scalars["GenericScalar"]["output"]>;
  userV2?: Maybe<UserDetailV2>;
  users?: Maybe<UserConnection>;
  validateCredentialUniqueName?: Maybe<ValidateCredentialName>;
  verifyEmail?: Maybe<VerifyEmail>;
};

export type QueryAccountArgs = {
  urlName: Scalars["String"]["input"];
};

export type QueryAccountsV2Args = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryBackfillArgs = {
  id: Scalars["String"]["input"];
};

export type QueryBackfillsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  created_datetime_after?: InputMaybe<Scalars["DateTime"]["input"]>;
  created_datetime_before?: InputMaybe<Scalars["DateTime"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  id?: InputMaybe<Scalars["String"]["input"]>;
  ids?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  report_datetime_after?: InputMaybe<Scalars["DateTime"]["input"]>;
  report_datetime_before?: InputMaybe<Scalars["DateTime"]["input"]>;
  search?: InputMaybe<Scalars["String"]["input"]>;
  status?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryChangelistArgs = {
  id?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryChangelistDiffArgs = {
  modified_id: Scalars["String"]["input"];
  original_id?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryCredentialArgs = {
  credential_type?: InputMaybe<Scalars["String"]["input"]>;
  name: Scalars["String"]["input"];
};

export type QueryCredentialsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  credentialTypes?: InputMaybe<Array<Scalars["String"]["input"]>>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  search?: InputMaybe<Scalars["String"]["input"]>;
  sortBy?: InputMaybe<Scalars["String"]["input"]>;
  sortDirection?: InputMaybe<Scalars["String"]["input"]>;
  statusFilters?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export type QueryDownloadArgs = {
  id: Scalars["String"]["input"];
};

export type QueryDownloadDetailsArgs = {
  downloadName: Scalars["String"]["input"];
  refresh?: Scalars["Boolean"]["input"];
};

export type QueryDownloadsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  bundleNames?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  bundle_name?: InputMaybe<Scalars["String"]["input"]>;
  dirty?: InputMaybe<Scalars["Boolean"]["input"]>;
  dirtyEqualsNewDirty?: InputMaybe<Scalars["Boolean"]["input"]>;
  downloaded_after?: InputMaybe<Scalars["Date"]["input"]>;
  downloaded_before?: InputMaybe<Scalars["Date"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  id?: InputMaybe<Scalars["String"]["input"]>;
  ids?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  names?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  newDirtyGreaterThanDirty?: InputMaybe<Scalars["Boolean"]["input"]>;
  project?: InputMaybe<Scalars["String"]["input"]>;
  projects?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  purpose?: InputMaybe<Scalars["String"]["input"]>;
  report_datetime_after?: InputMaybe<Scalars["Date"]["input"]>;
  report_datetime_before?: InputMaybe<Scalars["Date"]["input"]>;
  search?: InputMaybe<Scalars["String"]["input"]>;
  sortBy?: InputMaybe<DataGridSortableColumns>;
  sortDirection?: InputMaybe<SortDirection>;
  status?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryDraftsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  archived?: InputMaybe<Scalars["Boolean"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryEventArgs = {
  id: Scalars["String"]["input"];
};

export type QueryEventsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  backfill_id?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  created_after?: InputMaybe<Scalars["Date"]["input"]>;
  created_before?: InputMaybe<Scalars["Date"]["input"]>;
  downloadNames?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  id?: InputMaybe<Scalars["String"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  projectNames?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  purpose?: InputMaybe<Scalars["String"]["input"]>;
  report_datetime_after?: InputMaybe<Scalars["Date"]["input"]>;
  report_datetime_before?: InputMaybe<Scalars["Date"]["input"]>;
  search?: InputMaybe<Scalars["String"]["input"]>;
  severities?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  severity?: InputMaybe<Scalars["String"]["input"]>;
  uploadNames?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  withComments?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type QueryExportDeclarationArgs = {
  id?: InputMaybe<Scalars["String"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryExportDeclarationsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  changelist_id?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryExportStatusArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  group_by?: InputMaybe<Scalars["String"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  lookback_days?: InputMaybe<Scalars["Int"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  project?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryFlowDownloadsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  id: Scalars["String"]["input"];
  last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryFlowsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  archived?: InputMaybe<Scalars["Boolean"]["input"]>;
  backfill_id?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  failed?: InputMaybe<Scalars["Boolean"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  id?: InputMaybe<Scalars["String"]["input"]>;
  ids?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  phase?: InputMaybe<Scalars["String"]["input"]>;
  purpose?: InputMaybe<Scalars["String"]["input"]>;
  scriptbook_id?: InputMaybe<Scalars["String"]["input"]>;
  sortDirection?: InputMaybe<SortDirection>;
  status?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryHistoryArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryHomepageArgs = {
  refresh?: Scalars["Boolean"]["input"];
};

export type QueryImpactedDownloadsArgs = {
  credentialName: Scalars["String"]["input"];
};

export type QueryImpactedUploadsArgs = {
  credentialName: Scalars["String"]["input"];
};

export type QueryImportStatusArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  group_by?: InputMaybe<Scalars["String"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  lookback_days?: InputMaybe<Scalars["Int"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  project?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryIntegrationArgs = {
  id: Scalars["String"]["input"];
};

export type QueryIntegrationsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryKeyDetailsArgs = {
  keyName: Scalars["String"]["input"];
  refresh?: Scalars["Boolean"]["input"];
};

export type QueryLateUploadsArgs = {
  due_for_check?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type QuerySbsSchemaArgs = {
  name: Scalars["String"]["input"];
};

export type QueryScriptbookArgs = {
  scriptbookSha: Scalars["String"]["input"];
};

export type QuerySourceBundleArgs = {
  changelist_id?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["String"]["input"];
};

export type QuerySourceBundlesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  changelist_id?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  project?: InputMaybe<Scalars["String"]["input"]>;
};

export type QuerySourceTableArgs = {
  changelist_id?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["String"]["input"];
};

export type QueryStartOauthArgs = {
  entity: Scalars["String"]["input"];
  id?: InputMaybe<Scalars["String"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  oauthType: Scalars["String"]["input"];
};

export type QueryTasksArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  id?: InputMaybe<Scalars["String"]["input"]>;
  ids?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  status?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryUploadArgs = {
  id: Scalars["String"]["input"];
};

export type QueryUploadDetailsArgs = {
  refresh?: Scalars["Boolean"]["input"];
  uploadName: Scalars["String"]["input"];
};

export type QueryUploadsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  destination?: InputMaybe<Scalars["String"]["input"]>;
  dirty?: InputMaybe<Scalars["Boolean"]["input"]>;
  downloadPartIds?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  download_part_id?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  id?: InputMaybe<Scalars["String"]["input"]>;
  ids?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  names?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  project?: InputMaybe<Scalars["String"]["input"]>;
  projects?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  purpose?: InputMaybe<Scalars["String"]["input"]>;
  report_datetime_after?: InputMaybe<Scalars["Date"]["input"]>;
  report_datetime_before?: InputMaybe<Scalars["Date"]["input"]>;
  search?: InputMaybe<Scalars["String"]["input"]>;
  sortBy?: InputMaybe<DataGridSortableColumns>;
  sortDirection?: InputMaybe<SortDirection>;
  status?: InputMaybe<Scalars["String"]["input"]>;
  uploaded_after?: InputMaybe<Scalars["Date"]["input"]>;
  uploaded_before?: InputMaybe<Scalars["Date"]["input"]>;
};

export type QueryUserPreferenceArgs = {
  name: Scalars["String"]["input"];
};

export type QueryUserV2Args = {
  userId: Scalars["String"]["input"];
};

export type QueryUsersArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  listAll?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type QueryValidateCredentialUniqueNameArgs = {
  name: Scalars["String"]["input"];
};

export type QueryVerifyEmailArgs = {
  email: Scalars["String"]["input"];
};

export type Recipient = {
  __typename?: "Recipient";
  email: Scalars["String"]["output"];
  rules: Array<Rule>;
};

export type RecipientAlreadyExistsError = {
  __typename?: "RecipientAlreadyExistsError";
  field: Scalars["String"]["output"];
  message: Scalars["String"]["output"];
};

export type RemoveIntegration = {
  __typename?: "RemoveIntegration";
  ok: Scalars["Boolean"]["output"];
};

export type RemoveUserV2Errors = {
  __typename?: "RemoveUserV2Errors";
  errors?: Maybe<Array<AttachedToMoreAccountsError>>;
};

export type RemoveUserV2Result = RemoveUserV2Errors | ResultOk;

export type ResetAuth0Password = {
  __typename?: "ResetAuth0Password";
  ok: Scalars["Boolean"]["output"];
};

export type ResultOk = {
  __typename?: "ResultOk";
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

export type RowsReport = {
  __typename?: "RowsReport";
  backfillRowCount: Scalars["Int"]["output"];
  contracted?: Maybe<Scalars["Float"]["output"]>;
  forecast?: Maybe<Scalars["Float"]["output"]>;
  productionRowCount: Scalars["Int"]["output"];
  rows?: Maybe<Array<RowsReportRow>>;
  testRowCount: Scalars["Int"]["output"];
};

export type RowsReportRowsArgs = {
  dimensions?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  filters?: InputMaybe<RowsReportFiltersInput>;
};

export type RowsReportFiltersInput = {
  monthsAgo?: InputMaybe<Scalars["Int"]["input"]>;
  projects?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  purposes?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  topProjects?: InputMaybe<Scalars["Int"]["input"]>;
};

export type RowsReportRow = {
  __typename?: "RowsReportRow";
  month: Scalars["Int"]["output"];
  project?: Maybe<Scalars["String"]["output"]>;
  purpose?: Maybe<Scalars["String"]["output"]>;
  totalByteCount: Scalars["Float"]["output"];
  totalRowCount: Scalars["Float"]["output"];
  year: Scalars["Int"]["output"];
};

export type Rule = {
  __typename?: "Rule";
  id: Scalars["String"]["output"];
  matchOrder: Scalars["Int"]["output"];
  path: Scalars["String"]["output"];
  senderGlob?: Maybe<Scalars["String"]["output"]>;
  senderRegex?: Maybe<Scalars["String"]["output"]>;
  subjectGlob?: Maybe<Scalars["String"]["output"]>;
  subjectRegex?: Maybe<Scalars["String"]["output"]>;
};

export type RuleInput = {
  id?: InputMaybe<Scalars["String"]["input"]>;
  newIndex?: InputMaybe<Scalars["Int"]["input"]>;
  path?: InputMaybe<Scalars["String"]["input"]>;
  senderGlob?: InputMaybe<Scalars["String"]["input"]>;
  senderRegex?: InputMaybe<Scalars["String"]["input"]>;
  subjectGlob?: InputMaybe<Scalars["String"]["input"]>;
  subjectRegex?: InputMaybe<Scalars["String"]["input"]>;
};

export type SaveAccountError = ConflictingNameError | ConflictingUrlNameError;

export type SaveAccountErrors = {
  __typename?: "SaveAccountErrors";
  errors?: Maybe<Array<Maybe<SaveAccountError>>>;
};

export type SaveAccountResult = ResultOk | SaveAccountErrors;

export type SaveAccountV2Input = {
  /** Remove all daily summary email recipients. */
  clearSummaryRecipients?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Number of rows in the contracted plan */
  contractedRowCount?: InputMaybe<Scalars["BigInt"]["input"]>;
  /** new name; required for new account */
  name?: InputMaybe<Scalars["String"]["input"]>;
  /** Remove account default to check if an upload is late. */
  removeDefaultDeadline?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Disable daily summary email. */
  removeSummaryTime?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Set account default to check if an upload is late. */
  setDefaultDeadline?: InputMaybe<Scalars["String"]["input"]>;
  /** Set daily summary email recipients. */
  setSummaryRecipients?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** Activate daily summary email. */
  setSummaryTime?: InputMaybe<Scalars["String"]["input"]>;
  /** Show download summary */
  showDownloadSummary?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** New urlName; required for new account. */
  urlName?: InputMaybe<Scalars["String"]["input"]>;
};

export type SaveBackfillInput = {
  description?: InputMaybe<Scalars["String"]["input"]>;
  status?: InputMaybe<Scalars["String"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
};

export type SaveChangelistInput = {
  description?: InputMaybe<Scalars["String"]["input"]>;
  files?: InputMaybe<Array<InputMaybe<SaveFileInput>>>;
};

export type SaveChangelistOk = {
  __typename?: "SaveChangelistOk";
  /** Action taken: proof, publish, archive */
  action?: Maybe<Scalars["String"]["output"]>;
  changelist?: Maybe<Changelist>;
};

export type SaveChangelistResult = NeedsMergeError | SaveChangelistOk;

export type SaveCredentialInput = {
  credential_type?: InputMaybe<Scalars["String"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  properties?: InputMaybe<Scalars["GenericScalar"]["input"]>;
  status?: InputMaybe<Scalars["String"]["input"]>;
};

export type SaveCredentialOk = {
  __typename?: "SaveCredentialOk";
  credential?: Maybe<Credential>;
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

export type SaveCredentialOutput = InvalidCredential | SaveCredentialOk | ValidationErrors;

export type SaveDownloadBundle = {
  __typename?: "SaveDownloadBundle";
  download: DownloadBundle;
  ok: Scalars["Boolean"]["output"];
};

export type SaveEmailMatchOk = {
  __typename?: "SaveEmailMatchOk";
  email: Scalars["String"]["output"];
  rules: Array<Rule>;
};

export type SaveEmailMatchResult = InvalidPathError | InvalidRegexError | SaveEmailMatchOk;

export type SaveEmailRecipientOk = {
  __typename?: "SaveEmailRecipientOk";
  newEmail?: Maybe<Scalars["String"]["output"]>;
  oldEmail: Scalars["String"]["output"];
};

export type SaveEmailRecipientResult = RecipientAlreadyExistsError | SaveEmailRecipientOk;

export type SaveEvent = {
  __typename?: "SaveEvent";
  event: Event;
  ok: Scalars["Boolean"]["output"];
};

export type SaveEventInput = {
  comment?: InputMaybe<Scalars["String"]["input"]>;
};

export type SaveExport = {
  __typename?: "SaveExport";
  ok: Scalars["Boolean"]["output"];
};

export type SaveExportInput = {
  status?: InputMaybe<Scalars["String"]["input"]>;
};

export type SaveFileInput = {
  original_path?: InputMaybe<Scalars["String"]["input"]>;
  path: Scalars["String"]["input"];
  text?: InputMaybe<Scalars["String"]["input"]>;
};

export type SaveFileResult = ChangeFileSuccess | MissingSha;

export type SaveFlow = {
  __typename?: "SaveFlow";
  flow: Flow;
  ok: Scalars["Boolean"]["output"];
};

export type SaveFlowInput = {
  archived?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SaveIntegration = {
  __typename?: "SaveIntegration";
  integration: Integration;
  ok: Scalars["Boolean"]["output"];
};

export type SaveIntegrationInput = {
  authorization?: InputMaybe<Scalars["GenericScalar"]["input"]>;
  configuration?: InputMaybe<Scalars["GenericScalar"]["input"]>;
  filters?: InputMaybe<Array<InputMaybe<IntegrationFilterInput>>>;
  integration_type?: InputMaybe<Scalars["String"]["input"]>;
};

export type SavePreference = {
  __typename?: "SavePreference";
  ok: Scalars["Boolean"]["output"];
};

export type SaveSourceBundle = {
  __typename?: "SaveSourceBundle";
  bundle: SourceBundle;
  ok: Scalars["Boolean"]["output"];
};

export type SaveSourceBundleInput = {
  status?: InputMaybe<Scalars["String"]["input"]>;
};

export type SaveStatusInput = {
  status?: InputMaybe<Scalars["String"]["input"]>;
};

export type SaveUpload = {
  __typename?: "SaveUpload";
  ok: Scalars["Boolean"]["output"];
  upload: Upload;
};

export type SaveUserError = ConflictingEmailError | InsecurePasswordError;

export type SaveUserErrors = {
  __typename?: "SaveUserErrors";
  errors?: Maybe<Array<SaveUserError>>;
};

export type SaveUserResult = SaveUserErrors | SaveUserSuccessMutationResult;

export type SaveUserSuccessMutationResult = {
  __typename?: "SaveUserSuccessMutationResult";
  ok?: Maybe<Scalars["Boolean"]["output"]>;
  user?: Maybe<UserDetailV2>;
};

export type SaveUserV2Input = {
  /** Block user in auth0 */
  blocked?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** New email */
  email?: InputMaybe<Scalars["String"]["input"]>;
  /** new name */
  name?: InputMaybe<Scalars["String"]["input"]>;
  /** New password */
  password?: InputMaybe<Scalars["String"]["input"]>;
};

export type SbsSchema = {
  __typename?: "SbsSchema";
  name: Scalars["String"]["output"];
  text: Scalars["String"]["output"];
};

export type ScriptInput = {
  path: Scalars["String"]["input"];
  text: Scalars["String"]["input"];
};

export type ScriptbookCompilation = {
  __typename?: "ScriptbookCompilation";
  files: Array<FileCompilation>;
  messages: Array<Message>;
  scriptbookSha: Scalars["String"]["output"];
};

export type ScriptbookCompilationFilesArgs = {
  paths?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export type SetUserBlock = {
  __typename?: "SetUserBlock";
  ok: Scalars["Boolean"]["output"];
};

export enum SortDirection {
  Asc = "ASC",
  Desc = "DESC",
}

/**
 * A bundle of tables downloaded together. Many sources download only one table at a time. But others, like
 * `dfp:custom_targeting`, download two tables together: keys and values. And tarballs may download multiple tables
 * together. Named as per the Sources UI design; corresponds to the DB model ImportBundle.
 */
export type SourceBundle = {
  __typename?: "SourceBundle";
  bundle_name?: Maybe<Scalars["String"]["output"]>;
  descriptor?: Maybe<Scalars["GenericScalar"]["output"]>;
  id: Scalars["String"]["output"];
  import_type: Scalars["String"]["output"];
  next_probe?: Maybe<Scalars["DateTime"]["output"]>;
  /** Datetime of most recent download */
  recent_download?: Maybe<Scalars["DateTime"]["output"]>;
  recent_failed_probe?: Maybe<Scalars["DateTime"]["output"]>;
  recent_successful_probe?: Maybe<Scalars["DateTime"]["output"]>;
  report_handle?: Maybe<Scalars["GenericScalar"]["output"]>;
  status: Scalars["String"]["output"];
  tables: Array<Maybe<SourceTable>>;
  tasks: Array<Maybe<Task>>;
};

/**
 * A bundle of tables downloaded together. Many sources download only one table at a time. But others, like
 * `dfp:custom_targeting`, download two tables together: keys and values. And tarballs may download multiple tables
 * together. Named as per the Sources UI design; corresponds to the DB model ImportBundle.
 */
export type SourceBundleRecentDownloadArgs = {
  if_suspended?: InputMaybe<Scalars["Boolean"]["input"]>;
  purpose?: InputMaybe<Scalars["String"]["input"]>;
  status?: InputMaybe<Scalars["String"]["input"]>;
};

/**
 * A bundle of tables downloaded together. Many sources download only one table at a time. But others, like
 * `dfp:custom_targeting`, download two tables together: keys and values. And tarballs may download multiple tables
 * together. Named as per the Sources UI design; corresponds to the DB model ImportBundle.
 */
export type SourceBundleTablesArgs = {
  can_backfill?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SourceBundleConnection = {
  __typename?: "SourceBundleConnection";
  edges: Array<SourceBundleEdge>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

export type SourceBundleEdge = {
  __typename?: "SourceBundleEdge";
  cursor: Scalars["String"]["output"];
  node: SourceBundle;
};

export type SourceCompilation = {
  /** All messages for this source. */
  messages: Array<Message>;
};

/**
 * A table available in SBS for transforms or export. Named as per the Sources UI design; corresponds to the DB
 * models ImportPart and ImportDeclaration.
 */
export type SourceTable = {
  __typename?: "SourceTable";
  bundle?: Maybe<SourceBundle>;
  can_backfill: Scalars["Boolean"]["output"];
  changelist_id: Scalars["String"]["output"];
  credential?: Maybe<Credential>;
  declaration_id: Scalars["String"]["output"];
  descriptor?: Maybe<Scalars["GenericScalar"]["output"]>;
  exports: Array<Maybe<ExportDeclaration>>;
  id: Scalars["String"]["output"];
  line: Scalars["Int"]["output"];
  name: Scalars["String"]["output"];
  parameters?: Maybe<Scalars["GenericScalar"]["output"]>;
  project: Scalars["String"]["output"];
  schema: Scalars["GenericScalar"]["output"];
  volume: Volume;
};

export type SourceTableConnection = {
  __typename?: "SourceTableConnection";
  edges: Array<SourceTableEdge>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

export type SourceTableEdge = {
  __typename?: "SourceTableEdge";
  cursor: Scalars["String"]["output"];
  node: SourceTable;
};

export type Step = {
  __typename?: "Step";
  declarationName: Scalars["String"]["output"];
  destTables: Array<Scalars["String"]["output"]>;
  inputs?: Maybe<Array<Scalars["String"]["output"]>>;
  kind: StepKind;
  line: Scalars["Int"]["output"];
  name: Scalars["String"]["output"];
  outputs?: Maybe<Array<Scalars["String"]["output"]>>;
  project: Scalars["String"]["output"];
  sourceTables: Array<Scalars["String"]["output"]>;
};

export enum StepKind {
  BigqueryExtract = "BIGQUERY_EXTRACT",
  BigqueryLoad = "BIGQUERY_LOAD",
  BigqueryQuery = "BIGQUERY_QUERY",
  BundleTable = "BUNDLE_TABLE",
  Download = "DOWNLOAD",
  Upload = "UPLOAD",
}

export type Subgraph = {
  __typename?: "Subgraph";
  download_declarations: Array<Maybe<SourceBundle>>;
  id: Scalars["String"]["output"];
  upload_declarations: Array<Maybe<ExportDeclaration>>;
};

export type Task = {
  __typename?: "Task";
  awakens: Scalars["DateTime"]["output"];
  batch_id: Scalars["String"]["output"];
  batch_name: Scalars["GenericScalar"]["output"];
  created: Scalars["DateTime"]["output"];
  finished?: Maybe<Scalars["DateTime"]["output"]>;
  id: Scalars["String"]["output"];
  lock_id: Scalars["String"]["output"];
  lock_name: Scalars["GenericScalar"]["output"];
  retries: Scalars["Int"]["output"];
  started?: Maybe<Scalars["DateTime"]["output"]>;
  status: Scalars["String"]["output"];
  taken_by?: Maybe<Scalars["GenericScalar"]["output"]>;
  task_data?: Maybe<Scalars["GenericScalar"]["output"]>;
  task_type: Scalars["String"]["output"];
};

export type TaskConnection = {
  __typename?: "TaskConnection";
  edges: Array<TaskEdge>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

export type TaskEdge = {
  __typename?: "TaskEdge";
  cursor: Scalars["String"]["output"];
  node: Task;
};

export type Upload = {
  __typename?: "Upload";
  created: Scalars["DateTime"]["output"];
  destination?: Maybe<Scalars["String"]["output"]>;
  finished?: Maybe<Scalars["DateTime"]["output"]>;
  flow: Flow;
  handle?: Maybe<Scalars["GenericScalar"]["output"]>;
  id: Scalars["String"]["output"];
  inputs: Array<Maybe<DownloadPart>>;
  name: Scalars["String"]["output"];
  project: Scalars["String"]["output"];
  purpose?: Maybe<Scalars["String"]["output"]>;
  report_datetime?: Maybe<DateTimeHuman>;
  row_count?: Maybe<Scalars["Float"]["output"]>;
  started?: Maybe<Scalars["DateTime"]["output"]>;
  status: Scalars["String"]["output"];
};

export type UploadConnection = {
  __typename?: "UploadConnection";
  edges: Array<UploadEdge>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

export type UploadDeclaration = {
  __typename?: "UploadDeclaration";
  bqDataset?: Maybe<Scalars["String"]["output"]>;
  bqProject?: Maybe<Scalars["String"]["output"]>;
  bqTable?: Maybe<Scalars["String"]["output"]>;
  declarationId: Scalars["String"]["output"];
  downloads: Array<Scalars["String"]["output"]>;
  exportType: Scalars["String"]["output"];
  line?: Maybe<Scalars["Int"]["output"]>;
  name: Scalars["String"]["output"];
  query?: Maybe<Scalars["String"]["output"]>;
  sbProject?: Maybe<Scalars["String"]["output"]>;
  subgraphId: Scalars["String"]["output"];
};

export type UploadDependencySummary = {
  __typename?: "UploadDependencySummary";
  destination?: Maybe<Scalars["String"]["output"]>;
  name: Scalars["String"]["output"];
  status: Scalars["String"]["output"];
};

export type UploadDetails = {
  __typename?: "UploadDetails";
  destination?: Maybe<Scalars["String"]["output"]>;
  downloadsUsedByUpload: Array<DownloadDependencySummary>;
  event?: Maybe<HomepageEvent>;
  keysUsedByUpload: Array<KeyDependencySummary>;
  pos: Position;
  refreshedAt: Scalars["String"]["output"];
  scriptbookId: Scalars["String"]["output"];
  scriptbookKey: Scalars["String"]["output"];
  sparkline: Array<HomepageSparklineDay>;
  sparklineFirstDate: Scalars["String"]["output"];
  status: Scalars["String"]["output"];
};

export type UploadEdge = {
  __typename?: "UploadEdge";
  cursor: Scalars["String"]["output"];
  node: Upload;
};

export type UploadJournal = {
  __typename?: "UploadJournal";
  _name?: Maybe<Scalars["String"]["output"]>;
  completed?: Maybe<Scalars["Int"]["output"]>;
  date?: Maybe<Scalars["Date"]["output"]>;
  failed?: Maybe<Scalars["Int"]["output"]>;
  max_bytes?: Maybe<Scalars["Float"]["output"]>;
  max_rows?: Maybe<Scalars["Float"]["output"]>;
  min_bytes?: Maybe<Scalars["Float"]["output"]>;
  min_rows?: Maybe<Scalars["Float"]["output"]>;
  running?: Maybe<Scalars["Int"]["output"]>;
  total_bytes?: Maybe<Scalars["Float"]["output"]>;
  total_rows?: Maybe<Scalars["Float"]["output"]>;
};

export type User = {
  __typename?: "User";
  email: Scalars["String"]["output"];
  /** Global roles for this user. */
  globalRoles?: Maybe<Array<Scalars["String"]["output"]>>;
  id: Scalars["String"]["output"];
  name: Scalars["String"]["output"];
};

export type UserAccounts = {
  __typename?: "UserAccounts";
  id: Scalars["String"]["output"];
  name: Scalars["String"]["output"];
  roles: Array<Scalars["String"]["output"]>;
  show_download_summary?: Maybe<Scalars["Boolean"]["output"]>;
  urlName: Scalars["String"]["output"];
};

export type UserConnection = {
  __typename?: "UserConnection";
  edges: Array<UserEdge>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

export type UserDetailV2 = {
  __typename?: "UserDetailV2";
  accounts: Array<UserAccounts>;
  email: Scalars["String"]["output"];
  /** Global roles for this user. */
  globalRoles?: Maybe<Array<Scalars["String"]["output"]>>;
  id: Scalars["String"]["output"];
  identities: Array<Auth0Identity>;
  name: Scalars["String"]["output"];
};

export type UserEdge = {
  __typename?: "UserEdge";
  cursor: Scalars["String"]["output"];
  node: User;
};

export type ValidateCredentialName = ValidateCredentialOk | ValidationErrors;

export type ValidateCredentialOk = {
  __typename?: "ValidateCredentialOk";
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

export type ValidateIntegration = {
  __typename?: "ValidateIntegration";
  ok: Scalars["Boolean"]["output"];
};

export type ValidationError = {
  __typename?: "ValidationError";
  /** Information about the error, for use in the UI. */
  properties?: Maybe<Scalars["GenericScalar"]["output"]>;
  typeId: Scalars["String"]["output"];
};

export type ValidationErrors = {
  __typename?: "ValidationErrors";
  errors?: Maybe<Array<Maybe<ValidationError>>>;
};

export type VerifyEmail = {
  __typename?: "VerifyEmail";
  auth0Name?: Maybe<Scalars["String"]["output"]>;
  useIdP?: Maybe<Scalars["Boolean"]["output"]>;
  userId?: Maybe<Scalars["String"]["output"]>;
};

export type Volume = {
  __typename?: "Volume";
  backfill_bytes: Scalars["Float"]["output"];
  backfill_rows: Scalars["Float"]["output"];
  production_bytes: Scalars["Float"]["output"];
  production_rows: Scalars["Float"]["output"];
  proof_bytes: Scalars["Float"]["output"];
  proof_rows: Scalars["Float"]["output"];
  refill_bytes: Scalars["Float"]["output"];
  refill_rows: Scalars["Float"]["output"];
};

export enum JoinGraph {
  FastberryApi = "FASTBERRY_API",
  FrontendApi = "FRONTEND_API",
  ScriptingApi = "SCRIPTING_API",
}

export enum LinkPurpose {
  /** `EXECUTION` features provide metadata necessary for operation execution. */
  Execution = "EXECUTION",
  /** `SECURITY` features provide metadata necessary to securely resolve fields. */
  Security = "SECURITY",
}
